import React, { useState, Fragment } from 'react';
import { TicketsAPI } from '../../../api/apiConfig';
import { exportTicketsToExcel } from '../utils/ticketsExportExcel';

const CsvExport = ({ children, filterState, orgId, fileHeaders, type, searchValue }) => {
  const [disable, setDisable] = useState(false);

  const handleDownloadClick = async () => {
    if (disable) {
      return;
    }
    setDisable(true);
    try {
      if (type === 'ALL') {
        const response = await TicketsAPI.getAllTickets();
        const downloadableObj = response.data.data.map((curr) => ({
          ...curr,
          cts: new Date(curr.cts).toLocaleDateString('en-GB'),
          mts: new Date(curr.mts).toLocaleDateString('en-GB'),
        }));
        await exportTicketsToExcel(downloadableObj, fileHeaders);
      } else {
        const body = {
          orgId: orgId,
          searchValue,
        };

        if (filterState.type.length > 0) body.type = filterState.type.toString();
        if (filterState.priority.length > 0) body.priority = filterState.priority.toString();
        if (filterState.status.length > 0) body.status = filterState.status.toString();
        if (filterState.assignee.length > 0) body.assignee = filterState.assignee.toString();

        const newCsvData = await TicketsAPI.getDownloadable(body);

        const downloadableObj = newCsvData.data.ticketsData.map((curr) => ({
          ...curr,
          cts: new Date(curr.cts).toLocaleDateString('en-GB'),
          mts: new Date(curr.mts).toLocaleDateString('en-GB'),
        }));
        await exportTicketsToExcel(downloadableObj, fileHeaders);
      }
    } finally {
      setDisable(false);
    }
  };

  return (
    <Fragment>
      <div onClick={handleDownloadClick}>{children}</div>
    </Fragment>
  );
};

export default CsvExport;
